"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressSpinner = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
require("./progressSpinner.css");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Check_1 = require("@nbc-design/icons/lib/web/Check");
var Close_1 = require("@nbc-design/icons/lib/web/Close");
var NbcColor_1 = require("@nbc-design/icons/lib/web/NbcColor");
var ProgressSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.appearance, appearance = _c === void 0 ? 'normal' : _c, className = _a.className, _d = _a.dataTest, dataTest = _d === void 0 ? 'progress-spinner' : _d, _e = _a.ariaLabel, ariaLabel = _e === void 0 ? 'Loading' : _e, _f = _a.status, status = _f === void 0 ? '' : _f, customLogo = _a.customLogo, _g = _a.hideLogo, hideLogo = _g === void 0 ? false : _g, other = tslib_1.__rest(_a, ["size", "appearance", "className", "dataTest", "ariaLabel", "status", "customLogo", "hideLogo"]);
    var _h = React.useState(''), animationStatus = _h[0], setAnimationStatus = _h[1];
    var _j = React.useState(false), animationEnd = _j[0], setAnimationEnd = _j[1];
    var changeStatusTimeout = null;
    React.useEffect(function () {
        if (status === 'success' || status === 'error') {
            changeStatusTimeout = setTimeout(function () {
                setAnimationStatus(status);
                setAnimationEnd(true);
            }, 150);
        }
        else {
            setAnimationStatus('');
            setAnimationEnd(false);
        }
    }, [status]);
    React.useEffect(function () {
        return function () {
            changeStatusTimeout && clearTimeout(changeStatusTimeout);
            changeStatusTimeout = null;
        };
    }, []);
    var classes = (0, classnames_1.default)('dsc-progressSpinner', size !== 'medium' ? "is-".concat(size) : null, appearance === 'inverted' ? "is-".concat(appearance) : null, status !== '' && "is-".concat(status), animationEnd && 'is-terminated', className);
    var iconSize = size === 'xlarge' ? { width: 48, height: 48 } : size;
    var iconMarkup = function () {
        var logo = customLogo ? ((0, jsx_runtime_1.jsx)("div", { className: "dsc-progressSpinner__icon", children: customLogo })) : ((0, jsx_runtime_1.jsx)(NbcColor_1.NbcColor, { size: iconSize, title: ariaLabel, className: "dsc-progressSpinner__icon" }));
        return size !== 'small' && !hideLogo && logo;
    };
    var successMarkup = size !== 'small' && ((0, jsx_runtime_1.jsx)(Check_1.Check, { size: iconSize, title: ariaLabel, className: "dsc-progressSpinner__icon is-status" }));
    var errorMarkup = size !== 'small' && ((0, jsx_runtime_1.jsx)(Close_1.Close, { size: iconSize, title: ariaLabel, className: "dsc-progressSpinner__icon is-status" }));
    var animationRender = animationStatus === 'success' ? successMarkup : errorMarkup;
    var screenReaderTextMarkup = ariaLabel && size === 'small' && ((0, jsx_runtime_1.jsx)("div", { className: "dsc-sr-only", children: ariaLabel }));
    return ((0, jsx_runtime_1.jsxs)("div", tslib_1.__assign({}, other, { className: classes, "data-test": dataTest, role: "status", children: [screenReaderTextMarkup, (0, jsx_runtime_1.jsx)("div", { className: "dsc-progressSpinner__border" }), animationEnd ? animationRender : iconMarkup()] })));
};
exports.ProgressSpinner = ProgressSpinner;
exports.ProgressSpinner.displayName = 'ProgressSpinner';
//# sourceMappingURL=progressSpinner.js.map